export default {
  base: {
    left: 0,
    right: 0
  }
};